export const environment = {
  production: !window["env"]["debug"] || true,
  apiUrl: window["env"]["apiUrl"],
  rootUrl: window["env"]["rootUrl"],
  tokenKey: window["env"]["tokenKey"],
  geocodeApi: window["env"]["geocodeApi"],
};
